<app-page-header
    [title]="'Planning DvdS'"
    [subtitle]="'Personeel'"
    [print]="print"
    [showHelpIcon]="true"
    (onOpenHelpClick)="showHelp = !showHelp">
    <ng-container filters>
        <div class="d-flex gap-2">
            <ng-container *ngTemplateOutlet="filterProject"></ng-container>
            <ng-container *ngTemplateOutlet="filterPerformer"></ng-container>
            <ng-container *ngTemplateOutlet="filterRole"></ng-container>

            <div class="night-planning">
                <mat-checkbox [formControl]="fcNightPlanning" color="primary">Nacht</mat-checkbox>
            </div>
        </div>
    </ng-container>

    <app-date-indicator
        [disableNext]="disableNext"
        [fromDate]="fromDate"
        [primaryWeekEnd]="toDate"
        [primaryWeekStart]="fromDate"
        [print]="print"
        [toDate]="toDate"
        (next)="next()"
        (prev)="prev()"
        indicator>
    </app-date-indicator>

    <div class="d-flex mx-2" print-pdf>
        @if (!print) {
            <input
                #dateInput
                [matDatepicker]="picker"
                (dateChange)="onDateSelected($event)"
                matInput
                style="border: none; width: 0px; height: 0px" />

            <button class="menu-button" (click)="picker.open()" color="primary" mat-icon-button>
                <mat-icon class="calendar-icon" fontSet="far" fontIcon="fa-calendar-range"></mat-icon>
            </button>

            <mat-datepicker #picker (dateChange)="onDateSelected($event)"> </mat-datepicker>
        }
    </div>

    @if (!print && !readonly) {
        <div print-pdf>
            <div class="me-3">
                <button class="menu-button" (click)="pdf()" color="primary" mat-icon-button>
                    @if (downloadingPdf) {
                        <mat-spinner></mat-spinner>
                    } @else {
                        <mat-icon fontSet="fa-light" fontIcon="fa-file-pdf"></mat-icon>
                    }
                </button>
            </div>
        </div>
    }

    @if (!print) {
        <ng-container menu-filters>
            <ng-container *ngTemplateOutlet="filterProject"></ng-container>
            <ng-container *ngTemplateOutlet="filterPerformer"></ng-container>
            <ng-container *ngTemplateOutlet="filterRole"></ng-container>

            <div class="settings-menu-item">
                <div>Dag of nacht planning</div>
                <mat-checkbox [formControl]="fcNightPlanning" color="primary">Nacht</mat-checkbox>
            </div>
        </ng-container>
    }
</app-page-header>

@if (showHelp) {
    <app-employee-planning-help />
}

@if (dataLoadInProgress) {
    <div
        class="row-render-overlay position-fixed top-0 start-0 vw-100 vh-100 d-flex align-items-center justify-content-center bg-white user-select-none">
        <div class="d-flex flex-column align-items-center text-center gap-2">
            <mat-progress-spinner
                class="mb-1"
                color="primary"
                diameter="76"
                mode="indeterminate"></mat-progress-spinner>
            <div class="fw-bold">Personeelsplanning wordt geladen...</div>
        </div>
    </div>
} @else {
    <div class="employee-planning-overview" [class.night]="fcNightPlanning.value" [class.readonly]="readonly">
        <table class="table" #planningTable>
            <thead class="table-head">
                <tr class="projects">
                    <td class="table-head-title" colspan="2">Project:</td>
                    <td class="project" [colSpan]="leaveDays.length">WEEK</td>
                    @for (projectDays of projectDaysListFiltered; track projectDays.rowKey) {
                        <td
                            class="project curpoint"
                            [colSpan]="projectDays.days.length"
                            (click)="showProjectDetails(projectDays.project)">
                            <span>{{ projectDays.projectId }}</span>
                            @if (projectDayMatchesConfiguredPerformer(projectDays)) {
                                <i class="fa-light fa-users px-1"></i>
                            }
                            <br />
                            <small>{{ projectDays.project?.name }}</small>
                        </td>
                    }
                </tr>
                <tr class="project-info">
                    <td class="table-head-title" colspan="2">Plaats:</td>
                    <td [colSpan]="leaveDays.length"></td>
                    @for (projectDays of projectDaysListFiltered; track projectDays.rowKey) {
                        <td [colSpan]="projectDays.days.length">
                            @if (readonly) {
                                <div class="project-text-info">
                                    {{ projectDays.project?.location ?? '-' }}
                                </div>
                            } @else {
                                <app-location-select
                                    class="project-location-select"
                                    [control]="projectDays.form.controls.location"
                                    (addressSelected)="addressSelectedForProject($event, projectDays)"
                                    appearance="inline"
                                    source="EmployeePlanningComponent.location"
                                    resultFilter="localityOrTown">
                                </app-location-select>
                            }
                        </td>
                    }
                </tr>
                <tr class="project-info">
                    <td class="table-head-title" colspan="2">{{ environment.executorName | ucFirst }}:</td>
                    <td [colSpan]="leaveDays.length"></td>
                    @for (projectDays of projectDaysListFiltered; track projectDays.rowKey) {
                        <td [colSpan]="projectDays.days.length">
                            @if (readonly) {
                                <div class="project-text-info">
                                    {{ (executors | byId: projectDays.form.controls.performer_id.value)?.name ?? '-' }}
                                </div>
                            } @else {
                                <div class="d-flex align-items-center gap-1">
                                    <mat-select
                                        class="flex-grow-1"
                                        [formControl]="projectDays.form.controls.performer_id"
                                        [placeholder]="environment.executorName | ucFirst"
                                        panelWidth="250px">
                                        @for (executor of executors; track executor.id) {
                                            <mat-option [value]="executor.id">{{ executor.name }}</mat-option>
                                        }
                                    </mat-select>
                                    <button
                                        class="flex-shrink-0 border-0 bg-transparent p-0 add-button"
                                        (click)="addProjectDayVariant(projectDays, $event)"
                                        type="button">
                                        <mat-icon fontSet="fa-solid" fontIcon="fa-plus"></mat-icon>
                                    </button>
                                </div>
                            }
                        </td>
                    }
                </tr>
                <tr class="project-info">
                    <td class="table-head-title" colspan="2">Projectleider:</td>
                    <td [colSpan]="leaveDays.length"></td>
                    @for (projectDays of projectDaysListFiltered; track projectDays.rowKey) {
                        <td [colSpan]="projectDays.days.length">
                            @if (readonly) {
                                <div class="project-text-info">
                                    {{ (projectManagers | byId: projectDays.project.projectmanager_id)?.name ?? '-' }}
                                </div>
                            } @else {
                                <mat-select
                                    [formControl]="projectDays.form.controls.projectmanager_id"
                                    placeholder="Projectleider"
                                    panelWidth="250px">
                                    @for (projectManager of projectManagers; track projectManager.id) {
                                        <mat-option [value]="projectManager.id">
                                            {{ projectManager.name }}
                                        </mat-option>
                                    }
                                </mat-select>
                            }
                        </td>
                    }
                </tr>
                <tr class="days">
                    <th class="table-head-title" colspan="2">Personeel</th>
                    @for (day of leaveDays; track day.dayKey; let first = $first) {
                        <th
                            [class]="day.cssClass"
                            [attr.data-day]="day.dayKey"
                            [title]="day.dayLabel"
                            [class.first]="first">
                            {{ day.dayLetter }}
                        </th>
                    }
                    @for (projectDays of projectDaysListFiltered; track projectDays.rowKey) {
                        @for (day of projectDays.days; track day.dayKey; let first = $first) {
                            <th
                                [class]="day.cssClass"
                                [attr.data-day]="day.dayKey"
                                [attr.data-row-key]="projectDays.rowKey"
                                [title]="day.dayLabel"
                                [class.first]="first">
                                {{ day.dayLetter }}
                            </th>
                        }
                    }
                </tr>
            </thead>
            <tbody>
                @for (team of teams; track team.entity.id; let index = $index) {
                    @if (index === 0 || team.entityType.plural_name !== teams[index - 1].entityType.plural_name) {
                        <tr class="employee-function">
                            <td class="function-name" [colSpan]="2">
                                {{ team.entityType.plural_name }}
                            </td>
                            <td [colSpan]="(1 + projectDaysList.length) * 7"></td>
                        </tr>
                    }
                    <tr class="employee-row">
                        <td class="employee-name font-weight-bold" (click)="team.showUsers = !team.showUsers">
                            {{ team.entity.name }}
                        </td>
                        <td class="day day-count" (click)="team.showUsers = !team.showUsers">
                            @if (team.showUsers) {
                                <i class="fa-light fa-chevron-down"></i>
                            } @else {
                                <i class="fa-light fa-chevron-right"></i>
                            }
                        </td>
                        <ng-container [ngTemplateOutlet]="emptyLeaveDayCells"></ng-container>
                        @for (projectDays of projectDaysListFiltered; track projectDays.rowKey) {
                            @for (day of projectDays.days; track day.dayKey; let first = $first) {
                                <td
                                    class="day"
                                    [attr.data-day]="day.dayKey"
                                    [attr.data-row-key]="projectDays.rowKey"
                                    [class.first]="first"
                                    (click)="addTeamPlanning($event, day, team, projectDays.rowKey)">
                                    {{ getTeamCountForDay(day.dayKey, team, projectDays.rowKey) }}
                                </td>
                            }
                        }
                    </tr>
                    @if (team.showUsers && !print) {
                        @for (user of team.users; track user.id; let index = $index) {
                            <tr class="employee-row">
                                @let userWeekCountValue = userWeekCount.get(user.id);
                                <td class="employee-name">{{ user | userDisplayName }}</td>
                                <td
                                    class="day day-count"
                                    [class.warn]="userWeekCountValue < 5"
                                    title="Ingepland op {{ userWeekCountValue }} dagen">
                                    {{ userWeekCountValue }}
                                </td>
                                @for (day of leaveDays; track day.dayKey; let first = $first) {
                                    @let userDayKey = day.dayKey | makeKey: user.id;
                                    @let leaveDayUser = leaveDayUserMap.get(userDayKey);
                                    @let blockedUser = blockedMap?.get(userDayKey);
                                    @let dayUser = dayUserMap.get(userDayKey);
                                    @let userDayHasConflict = userDayConflictMap.get(userDayKey);
                                    <td
                                        class="day"
                                        [class.night]="userDayHasNightMap.get(userDayKey)"
                                        [class.text-danger]="userDayHasConflict"
                                        [attr.data-day]="day.dayKey"
                                        [attr.title]="
                                            leaveDayUser
                                                ? (leaveDayUser?.hourtype | hourtype) +
                                                  ' - ' +
                                                  (leaveDayUser?.comment ?? '') +
                                                  ' ' +
                                                  (leaveDayUser?.afas_project_id ?? '')
                                                : null
                                        "
                                        [class.first]="first"
                                        [cdkContextMenuTriggerFor]="context_menu"
                                        (click)="addOrRemoveLeave(user, day.day)"
                                        (contextmenu)="contextUser = user; contextDay = day.day">
                                        <div class="d-flex flex-column">
                                            @if (leaveDayUser) {
                                                <i class="fa-solid {{ leaveDayUser.hourtype | hourtypeIcon }}"></i>
                                            }
                                            @if (blockedUser) {
                                                <i class="fa-regular {{ blockedUser.icon }}"></i>
                                            }
                                            @if (dayUser) {
                                                <i class="fa-thin fa-user" [title]="dayUser"></i>
                                            }
                                        </div>
                                    </td>
                                }
                                @for (projectDays of projectDaysListFiltered; track projectDays.rowKey) {
                                    @for (day of projectDays.days; track day.dayKey; let first = $first) {
                                        @let userDayKey = day.dayKey | makeKey: user.id;
                                        @let projectDayUserKey = userDayKey | makeKey: projectDays.rowKey;
                                        @let projectDayUser = projectDayUserMap.get(projectDayUserKey);
                                        @let dayUser = dayUserMap.get(userDayKey);
                                        @let blockedUser = blockedMap?.get(userDayKey);
                                        @let userDayHasConflict = userDayConflictMap.get(userDayKey);
                                        <td
                                            class="day"
                                            [class.night]="projectDayUser | employeeIsNight"
                                            [attr.data-day]="day.dayKey"
                                            [attr.data-row-key]="projectDays.rowKey"
                                            [class.empty]="!day.project?.afas_project_id"
                                            [class.text-danger]="userDayHasConflict"
                                            [class.first]="first"
                                            (click)="addUserPlanningTeam($event, day, team, user, projectDays.rowKey)">
                                            @if (projectDayUser?.type === 'planning') {
                                                <i class="fa-light fa-truck"></i>
                                            } @else if (
                                                projectDayUser?.type === 'userPlanning' ||
                                                projectDayUser?.type === 'project'
                                            ) {
                                                <i class="fa-light fa-user"></i>
                                            } @else if (dayUser) {
                                                <i class="fa-solid fa-x text-white" [title]="dayUser"></i>
                                            }
                                            @if (blockedUser) {
                                                <i class="fa-regular {{ blockedUser.icon }}"></i>
                                            }
                                        </td>
                                    }
                                }
                            </tr>
                        }
                    }
                }
                @for (uniqueRole of filteredUniqueRoles; track uniqueRole.key) {
                    <tr class="employee-function">
                        <td class="function-name" [colSpan]="2">
                            {{ uniqueRole.name }}
                        </td>
                        <td [colSpan]="(1 + projectDaysList.length) * 7"></td>
                    </tr>
                    @for (user of uniqueRole.users; track user.id) {
                        <tr
                            class="employee-row"
                            [class.readonly]="readonly"
                            [blockedMap]="blockedMap"
                            [contextMenu]="context_menu"
                            [dayUserMap]="dayUserMap"
                            [leaveDayUserMap]="leaveDayUserMap"
                            [leaveDays]="leaveDays"
                            [projectDays]="projectDaysListFiltered"
                            [projectDayUserMap]="projectDayUserMap"
                            [user]="user"
                            [userDayConflictMap]="userDayConflictMap"
                            [userDayHasNightMap]="userDayHasNightMap"
                            [weekCount]="userWeekCount.get(user.id)"
                            [print]="print"
                            (contextMenuOpened)="contextUser = user; contextDay = $event"
                            (leaveClicked)="addOrRemoveLeave(user, $event)"
                            (projectClicked)="
                                addUserPlanningProject(
                                    $event.event,
                                    $event.day,
                                    $event.projectDayUser,
                                    user,
                                    false,
                                    $event.performerId,
                                    $event.rowKey
                                )
                            "
                            app-employee-planning-user-row></tr>
                    }
                }
                <tr class="employee-function">
                    <td class="function-name" [colSpan]="2">Klein materieel</td>
                    <td [colSpan]="(1 + projectDaysList?.length) * 7"></td>
                </tr>
                @for (entity of smallMaterial; track entity.id; let index = $index) {
                    <tr class="employee-row">
                        <td class="employee-name" [colSpan]="2">
                            <div class="text-right" [title]="entity.name">{{ entity.name }}</div>
                        </td>
                        <ng-container [ngTemplateOutlet]="emptyLeaveDayCells"></ng-container>
                        @for (projectDays of projectDaysListFiltered; track projectDays.rowKey) {
                            @for (day of projectDays.days; track day.dayKey; let first = $first) {
                                @let projectDayMaterial =
                                    getProjectDayMaterialEntry(
                                        day.dayKey,
                                        entity.id,
                                        day.project?.afas_project_id,
                                        projectDays.rowKey,
                                        null,
                                        projectDays.form.controls.performer_id.value
                                    );
                                <td
                                    class="day"
                                    [class.night]="day.day | entityIsNight: projectDayMaterial"
                                    [attr.data-day]="day.dayKey"
                                    [attr.data-row-key]="projectDays.rowKey"
                                    [class.first]="first"
                                    (click)="
                                        addEntityPlanning(
                                            $event,
                                            day,
                                            entity,
                                            undefined,
                                            false,
                                            projectDays.rowKey,
                                            projectDays.form.controls.performer_id.value
                                        )
                                    ">
                                    @if (projectDayMaterial) {
                                        <div class="d-flex flex-column">
                                            @if (projectDayMaterial[0]?.planning_id) {
                                                <i class="fa-light fa-truck-container-empty"></i>
                                            }
                                            @if (projectDayMaterial[0]?.afas_project_id) {
                                                <i class="fa-light fa-truck-plow"></i>
                                            }
                                        </div>
                                    }
                                </td>
                            }
                        }
                    </tr>
                }
                @for (hireEntity of hireEntities; track hireEntity.id; let index = $index) {
                    <tr class="employee-function">
                        <td class="function-name" [colSpan]="2">
                            <div class="d-flex w-100 justify-content-between align-items-center">
                                <span>{{ hireEntity.name }}</span>
                                @if (!readonly) {
                                    <i class="fas fa-plus curpoint" (click)="startAddHiring(hireEntity)"></i>
                                }
                            </div>
                        </td>
                        <td [colSpan]="(1 + projectDaysList.length) * 7"></td>
                    </tr>
                    @if (addingHiringForEntityId == hireEntity.id) {
                        <tr class="add-hiring">
                            <td [colSpan]="2">
                                <input
                                    #addHiringInp
                                    [matAutocomplete]="hiring"
                                    [formControl]="fcAddHiring"
                                    (keydown.enter)="addHiringFromInput()"
                                    matInput
                                    placeholder="Naam inhuur"
                                    type="text" />
                                <mat-autocomplete
                                    class="location-complete"
                                    #hiring="matAutocomplete"
                                    (optionSelected)="addHiring($event.option.value)"
                                    autoActiveFirstOption>
                                    @for (option of hiringAutocompleteOptions; track option) {
                                        <mat-option [value]="option">{{ option }}</mat-option>
                                    }
                                </mat-autocomplete>
                            </td>
                            <td [colSpan]="(projectDaysList.length + 1) * 7"></td>
                        </tr>
                    }
                    @for (user of entityHiringNames.get(hireEntity.id); track user; let index = $index) {
                        <tr class="employee-row">
                            @let entityWeekUsedDaysCount = entityWeekUsedDays.get(user + hireEntity.id)?.length ?? 0;
                            <td class="employee-name">
                                {{ user }}
                            </td>
                            <td
                                class="day day-count"
                                [class.warn]="entityWeekUsedDaysCount > 5"
                                title="Ingepland op {{ entityWeekUsedDaysCount }} dagen">
                                <div class="count">
                                    {{ entityWeekUsedDaysCount || '' }}
                                </div>
                                <div class="remove">
                                    <i class="fas fa-times" (click)="removeHire(hireEntity.id, user)"></i>
                                </div>
                            </td>
                            <ng-container [ngTemplateOutlet]="emptyLeaveDayCells"></ng-container>
                            @for (projectDays of projectDaysListFiltered; track projectDays.rowKey) {
                                @for (day of projectDays.days; track day.dayKey; let first = $first) {
                                    @let projectDayMaterial =
                                        getProjectDayMaterialEntry(
                                            day.dayKey,
                                            hireEntity.id,
                                            day.project?.afas_project_id,
                                            projectDays.rowKey,
                                            user,
                                            projectDays.form.controls.performer_id.value
                                        );
                                    <td
                                        class="day"
                                        [class.night]="day.day | entityIsNight: projectDayMaterial"
                                        [attr.data-day]="day.dayKey"
                                        [attr.data-row-key]="projectDays.rowKey"
                                        [class.first]="first"
                                        (click)="
                                            addEntityPlanning(
                                                $event,
                                                day,
                                                hireEntity,
                                                user,
                                                false,
                                                projectDays.rowKey,
                                                projectDays.form.controls.performer_id.value
                                            )
                                        ">
                                        @if (projectDayMaterial) {
                                            <i
                                                class="fa-light"
                                                [class.fa-user-helmet-safety]="
                                                    hireEntity.id === EntityId.HiringEmployee
                                                "
                                                [class.fa-truck-plow]="hireEntity.id === EntityId.HiringMaterials">
                                            </i>
                                        }
                                    </td>
                                }
                            }
                        </tr>
                    }
                }
            </tbody>
        </table>
    </div>
}

<ng-template #emptyLeaveDayCells>
    @for (day of leaveDays; track day.dayKey; let first = $first) {
        <td class="day" [attr.data-day]="day.dayKey" [class.first]="first"></td>
    }
</ng-template>

@if (!print && !readonly) {
    <div class="action-buttons">
        <button
            class="responsive-fab"
            [disabled]="saving || rollingBack"
            (click)="addProject()"
            mat-fab
            color="accent"
            matTooltip="Project toevoegen"
            matTooltipPosition="left">
            <mat-icon fontSet="fa-solid" fontIcon="fa-plus"></mat-icon>
        </button>
        <button
            class="responsive-fab"
            [disabled]="
                rollingBack ||
                saving ||
                (!userPlanningsToSave?.length &&
                    !planningHasToSave?.length &&
                    !leavesToSave?.length &&
                    !projectDayPerformerChangesToSave?.length)
            "
            (click)="undo()"
            mat-fab
            color="accent"
            matTooltipPosition="left"
            matTooltip="Wijzigingen ongedaan maken">
            @if (rollingBack) {
                <mat-spinner diameter="20"></mat-spinner>
            } @else {
                <mat-icon fontSet="fa-solid" fontIcon="fa-rotate-left"></mat-icon>
            }
        </button>
        <button
            class="responsive-fab"
            [disabled]="
                saving ||
                (!userPlanningsToSave?.length &&
                    !planningHasToSave?.length &&
                    !leavesToSave?.length &&
                    !projectDayPerformerChangesToSave?.length &&
                    !formDirty)
            "
            (click)="save()"
            mat-fab
            color="primary"
            matTooltipPosition="left"
            matTooltip="Wijzigingen opslaan">
            @if (saving) {
                <mat-spinner diameter="20"></mat-spinner>
            } @else {
                <mat-icon fontSet="fa-regular" fontIcon="fa-floppy-disk"></mat-icon>
            }
        </button>
    </div>
}

<ng-template #filterProject>
    <mat-form-field class="planning-filter-field" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Selecteer projecten</mat-label>
        <mat-select [formControl]="fcProjectIds" multiple>
            @for (projectId of uniqueProjectsIds; track projectId) {
                <mat-option [value]="projectId">{{ projectId }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
</ng-template>

<ng-template #filterPerformer>
    <mat-form-field class="planning-filter-field" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Selecteer {{ environment.executorName }}</mat-label>
        <mat-select [formControl]="fcPerformerIds" multiple>
            @for (executor of filteredExecutors; track executor.id) {
                <mat-option [value]="executor.id">{{ executor.name }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
</ng-template>

<ng-template #filterRole>
    <mat-form-field class="planning-filter-field" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Selecteer functies</mat-label>
        <mat-select [formControl]="fcRoleKeys" multiple>
            @for (uniqueRole of uniqueRoles; track uniqueRole.key) {
                <mat-option [value]="uniqueRole.key">{{ uniqueRole.name }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
</ng-template>

<ng-template #context_menu>
    <div class="context-menu" cdkMenu>
        <div class="menu-title">{{ contextDay | date: 'EEEE' }} - {{ contextUser?.name }}</div>
        <div class="divider"></div>
        <button class="menu-item info" (click)="showInfoDialog()" cdkMenuItem>
            <i class="fa-regular fa-memo-circle-info"></i> Details dag
        </button>

        @if (!readonly) {
            <div class="divider"></div>
            @if (contextUser?.afas_employee_id?.substring(0, 1) === 'Z') {
                <button
                    class="menu-item"
                    [class.active]="currentHourType === RealisationHourtype.zzp_leave"
                    (click)="setHourType(RealisationHourtype.zzp_leave)"
                    cdkMenuItem>
                    <i class="fa-solid {{ RealisationHourtype.zzp_leave | hourtypeIcon }}"></i> ZZP N/b
                </button>
            } @else {
                <button
                    class="menu-item"
                    [class.active]="currentHourType === RealisationHourtype.frost"
                    (click)="setHourType(RealisationHourtype.frost)"
                    cdkMenuItem>
                    <i class="fa-solid {{ RealisationHourtype.frost | hourtypeIcon }}"></i> Spaaruren
                </button>
                <button
                    class="menu-item"
                    [class.active]="currentHourType === RealisationHourtype.time_for_time"
                    (click)="setHourType(RealisationHourtype.time_for_time)"
                    cdkMenuItem>
                    <i class="fa-solid {{ RealisationHourtype.time_for_time | hourtypeIcon }}"></i> Tijd voor tijd
                </button>
                <button
                    class="menu-item"
                    [class.active]="currentHourType === RealisationHourtype.paid_leave"
                    (click)="setHourType(RealisationHourtype.paid_leave)"
                    cdkMenuItem>
                    <i class="fa-solid {{ RealisationHourtype.paid_leave | hourtypeIcon }}"></i> Doorbetaald verlof
                </button>
                <button
                    class="menu-item"
                    [class.active]="currentHourType === RealisationHourtype.short_absence"
                    (click)="setHourType(RealisationHourtype.short_absence)"
                    cdkMenuItem>
                    <i class="fa-solid {{ RealisationHourtype.short_absence | hourtypeIcon }}"></i> Kort verzuim
                </button>
                <button
                    class="menu-item"
                    [class.active]="currentHourType === RealisationHourtype.education"
                    (click)="setHourType(RealisationHourtype.education)"
                    cdkMenuItem>
                    <i class="fa-solid {{ RealisationHourtype.education | hourtypeIcon }}"></i> Scholing
                </button>
                <button
                    class="menu-item"
                    [class.active]="currentHourType === RealisationHourtype.bank_holiday"
                    (click)="setHourType(RealisationHourtype.bank_holiday)"
                    cdkMenuItem>
                    <i class="fa-solid {{ RealisationHourtype.bank_holiday | hourtypeIcon }}"></i> Feestdag
                </button>
                <button
                    class="menu-item"
                    [class.active]="currentHourType === RealisationHourtype.sleep"
                    (click)="setHourType(RealisationHourtype.sleep)"
                    cdkMenuItem>
                    <i class="fa-solid {{ RealisationHourtype.sleep | hourtypeIcon }}"></i> Slapen
                </button>
            }
        }
    </div>
</ng-template>
